import SignatureV1 from "../../../../components/form_builder/elements/signature/SignatureV1.vue";
import { validateRequired } from "../../../../helpers/validation";

export default {
  componentName: "fb-signature-v1",
  component: SignatureV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      description: "",
      value: "",
      required: false,
      hidden: false,
      style: {},
      eFormEditable: true,
      type: "user",
      dateEditable: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) =>
      value
        ? `
    <div>
      <img width="83" height="50" src="${value.signature}" />
    </div>`
        : ""
  },
  validate: ({ value, properties, form }) => {
    const errors = [];
    if (properties.required && !validateRequired(value)) {
      if(!(form.showType == "form-submitter" && properties.type == "client"))
        errors.push("This field is required");
    }
    return errors;
  }
};
